import axios, { AxiosResponse } from 'axios';
import { ILeiData } from 'types/leiTypes';

const leiDataApi = (method: 'put' | 'post' | 'get', idZadosti: number, varsym: string, data?: ILeiData) => {
    return axios({
        method: method,
        url: `LEI/${varsym}/registrace/${idZadosti}`,
        data: data
    }).then((resp: AxiosResponse<ILeiData>) => resp.data);
};

export default leiDataApi;
